import { TextField } from 'mui-rff';
import React, { useMemo, useState } from 'react';

import Form from '@dashboard/components/form/Form';
import { useCreateContactsGroupContactMutation } from '@dashboard/generated/wp/platform';
import { AddOutlined } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { alertError, alertSuccess } from '@wp-react/notifications';

import useCurrentContactsGroup from '../useCurrentContactsGroup';
import useCurrentContactsGroupContacts from '../useCurrentContactsGroupContacts';

type Props = {
  id: string;
};
export default function CreateContactsGroupContact({ id }: Props) {
  const [open, setOpen] = useState(false);
  const [createContact, { loading }] = useCreateContactsGroupContactMutation();
  const { refetch } = useCurrentContactsGroup();
  const { refetch: contactsRefetch } = useCurrentContactsGroupContacts();

  const onSubmit = async ({ contactEmailAddress }: { contactEmailAddress: string }) => {
    try {
      await createContact({ variables: { contactsGroupId: id, contactEmailAddress } });
      await refetch();
      await contactsRefetch();
      alertSuccess('Contact added');
      onClose();
    } catch (e) {
      alertError('Failed to add a contact');
    }
  };

  const onClose = () => setOpen(false);
  const initialValues = useMemo(() => ({ contactEmailAddress: '' }), []);

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        size="small"
        startIcon={<AddOutlined />}
        onClick={() => setOpen(true)}
      >
        Add contact
      </Button>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>Add to unsubscribed group</DialogTitle>
        <Form initialValues={initialValues} onSubmit={onSubmit}>
          <DialogContent>
            <Stack spacing={2}>
              <TextField
                autoFocus
                margin="normal"
                label="Email address"
                name="contactEmailAddress"
                placeholder="fred@example.com"
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} color="secondary" onClick={onClose}>
              Cancel
            </Button>
            <Button disabled={loading} variant="contained" type="submit">
              Add contact
            </Button>
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
